import store from '@/store';

export default function checkAuthInPublic({ next, router }) {
  if(store.state.auth.authenticated)
    return router.push({ name: 'home.index' });
  return next();
}
